
// Actions
const LOAD   = 'actions/events/LOAD';
const SAVE = 'actions/events/SAVE';
const CREATE = 'actions/events/CREATE';
const UPDATE = 'actions/events/UPDATE';
const REMOVE = 'actions/events/REMOVE';

// Reducer
export default function reducer(state = [], action = {}) {
  switch (action.type) {
    case SAVE: 
      const data = {
        id: state.length,
        preview: action.data.image,
        ...action.data,
        stats: {
          impressions: 0,
          openrate: 0,
          clickrate: 0,
          cta: 0,
        }
      }
      return [...state, data];
    default: return state;
  }
}

// Action Creators
export function loadEvents() {
  return { type: LOAD };
}

export function saveEvent(data) {
  return { type: SAVE, data };
}

export function createEvent(data) {
  return { type: CREATE, data };
}

export function updateEvent(data) {
  return { type: UPDATE, data };
}

export function removeEvent(data) {
  return { type: REMOVE, data };
}

// side effects, only as applicable
// e.g. thunks, epics, etc
// export function getEvent () {
//   return dispatch => get('/data').then(data => dispatch(updateEvent(data)))
// }


// WEBPACK FOOTER //
// ./src/actions/events.js